<template>
  <step-section
    :title="$t('opening')"
    :step-number="getStepNumber('windowOpeningType')"
    :loading="loading$"
  >
    <div class="row row--custom">
      <div
        class="col-6 col-xs-4 col-sm-3 col-md-4 col-lg-3 col-xl-2 col-custom-16 col-small-p"
        v-for="item in openingTypes"
        :key="item.id"
      >
        <window-type-block
          class="step-block--window-type-open"
          v-bind="item"
          :checked="isItemChecked('windowOpeningType.id', item.id)"
          @click="handleItemClick(item)"
        />
      </div>
    </div>
  </step-section>
</template>

<script>
  import WindowTypeBlock from '@/components/blocks/WindowTypeBlock.vue';
  import stepMixin from './stepMixin';

  export default {
    name: 'WindowOpeningTypeStep',
    mixins: [stepMixin],
    props: {
      openingTypes: Array,
    },
    methods: {
      handleItemClick(windowOpeningType) {
        this.updateFormField({
          field: 'windowOpeningType',
          value: {
            id: windowOpeningType.id,
            name: windowOpeningType.name,
          },
        });
      },
    },
    components: {
      WindowTypeBlock,
    },
  };
</script>
